import { render, staticRenderFns } from "./SystemInfo.vue?vue&type=template&id=5418c538"
import script from "./SystemInfo.vue?vue&type=script&lang=ts"
export * from "./SystemInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports